<template>
  <div class="rock-table-button-group flex flex-wrap">
    <template
      v-for="(item, index) in newList.filter((x) => x.visible === true)"
    >
      <vxe-button
        v-if="item.visible"
        :key="index"
        v-perm="[$route.meta.guard.permission + ':' + item.perm]"
        :status="item.status || 'primary'"
        :icon="item.icon"
        :content="
          (item.perm === 'del' ? '批量' : '') +
          permBtnName($route.meta.guard.permission + ':' + item.perm)
        "
        @click="handleClick(item.perm)"
      />
    </template>
    <vxe-button
      v-if="newList.filter((x) => x.visible === false).length"
      status="primary"
      :size="vxeSize"
      transfer
    >
      <template #default>更多操作</template>
      <template #dropdowns>
        <template
          v-for="(item, index) in newList.filter((x) => x.visible === false)"
        >
          <vxe-button
            :key="'dropdown' + index"
            v-perm="[$route.meta.guard.permission + ':' + item.perm]"
            type="text"
            :status="item.status || ''"
            :content="
              (item.perm === 'del' ? '批量' : '') +
              permBtnName($route.meta.guard.permission + ':' + item.perm)
            "
            @click="handleClick(item.perm)"
          />
        </template>
      </template>
    </vxe-button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { permBtnName } from "@/utils/permission";
import { hasPermission } from "@/utils/permission";

export default {
  name: "RockTableButtonGroupBackUp",
  install(Vue) {
    Vue.component("RockTableButtonGroupBackUp", this);
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      permBtnName,
      newList: [],
    };
  },
  computed: {
    ...mapGetters({
      vxeSize: "vxeSize",
      screenWidth: "screenWidth",
    }),
  },
  watch: {
    screenWidth: {
      handler() {
        this.handleDetail();
      },
      immediate: true,
    },
  },
  methods: {
    handleDetail() {
      const noVisibleNum = this.newList.filter(
        (x) => x.visible === false
      ).length;
      const list = this.options.map((item) => ({ ...item, visible: false }));
      const iconWidth = 13.2;
      const padding = 12 * 2;
      const aFontWidth = 12;
      const fontMargin = 4;
      const marginLeft = 12;
      const emptyWidth = this.screenWidth - 85 - 156 - 30 * 4 - 115.2;
      let width = noVisibleNum ? 114.41 : 0;
      list.forEach((item) => {
        if (hasPermission(item.perm)) {
          let font = this.permBtnName(
            this.$route.meta.guard.permission + ":" + item.perm
          );
          if (item.perm === "del") font = "批量删除";
          if (font) {
            width +=
              (width ? marginLeft : 0) +
              padding +
              iconWidth +
              font.length * aFontWidth +
              fontMargin;
            item.visible = width < emptyWidth;
          }
        }
      });
      this.newList = list;
    },
    handleClick(perm) {
      this.$emit("click", perm);
    },
  },
};
</script>

<style scoped lang="scss">
.rock-table-button-group {
  ::v-deep .vxe-button.size--medium {
    font-size: 12px;
  }
}
</style>
